import { IMonthlyReportResponse } from "types/Report/Report";
import {
  IReportByIdResponse,
  IReportResponse,
} from "types/Report/ReportResponse";

import { api } from ".";

const reportsQuery = api.injectEndpoints({
  endpoints: (builder) => ({
    getReports: builder.query<IReportResponse, { accountId?: string }>({
      query: ({ accountId }) =>
        accountId ? `/reports/all?accountId=${accountId}` : "/reports/all",
    }),

    getReportById: builder.query<IReportByIdResponse, string>({
      query: (id) => `/reports/${id}`,
    }),

    generateNewReport: builder.mutation<{ reportId: string; file: File }, any>({
      query: ({ reportId, file }) => {
        const formData = new FormData();

        formData.append("file", file);

        return {
          url: `/reports/${reportId}`,
          method: "PATCH",
          body: formData,
          formData: true,
        };
      },
    }),
    replaceReportDocument: builder.mutation<
      any,
      { reportId: string; file: File }
    >({
      query: ({ reportId, file }) => {
        const formData = new FormData();
        formData.append("file", file);

        return {
          url: `/reports/${reportId}/document`,
          method: "PUT",
          body: formData,
          formData: true,
        };
      },
    }),
    publishReport: builder.mutation<any, { reportId: string }>({
      query: ({ reportId }) => ({
        url: `/reports/${reportId}/publish`,
        method: "PUT",
      }),
      onQueryStarted: async ({ reportId }, { dispatch, queryFulfilled }) => {
        try {
          const { data: updatedReport } = await queryFulfilled;

          dispatch(
            reportsQuery.util.updateQueryData("getReports", {}, (draft) => {
              const reportIndex = draft?.data?.findIndex(
                (r) => r.id === reportId
              );
              if (
                reportIndex !== -1 &&
                reportIndex !== undefined &&
                draft?.data
              ) {
                // Extract just the report data (not the wrapper with message)
                if (updatedReport && updatedReport.data) {
                  draft.data[reportIndex] = updatedReport.data;
                }
              }
            })
          );
        } catch {
          // If the mutation fails, we don't need to do anything
          // The error will be handled by the component
        }
      },
    }),
    markReportDownloaded: builder.mutation<any, { reportId: string }>({
      query: ({ reportId }) => {
        return {
          url: `/reports/${reportId}/mark_downloaded`,
          method: "PUT",
        };
      },
    }),
    generateMonthlySalesReport: builder.mutation<
      IMonthlyReportResponse,
      { dateStart: any; dateEnd: any; orderType: any }
    >({
      query: ({ dateStart, dateEnd, orderType }) => {
        return {
          url: `/reports/generate/monthly-sales`,
          method: "POST",
          body: { dateStart, dateEnd, orderType },
          formData: true,
        };
      },
    }),
  }),
});

export const {
  useGetReportsQuery,
  useGetReportByIdQuery,
  useGenerateNewReportMutation,
  useReplaceReportDocumentMutation,
  usePublishReportMutation,
  useMarkReportDownloadedMutation,
  useGenerateMonthlySalesReportMutation,
} = reportsQuery;
